import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation } from 'react-query';
import { generateTasksReport } from './Report.service';
import { ReportTasksParams } from './Report.types';

export function useGenerateTaskReport() {
  const intl = useIntl().formatMessage;
  const translate = (message: string) =>
    intl({ id: `inventory.report.notifications.success.${message}` });
  const mutation = useMutation(
    (obj: ReportTasksParams) => generateTasksReport(obj),
    {
      onSuccess() {
        notification.success({
          message: translate('title'),
          description: translate('description'),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
